import styled from "styled-components";
import { StandardTableSortablePropertyHeader, ThemedTableHeader } from "../../../components/tables/StandardTable";

const FixedWidthHeader = styled(StandardTableSortablePropertyHeader)`
    width: ${({ width }) => width}%
`;


const HubwiseJobsTableHeader = ({ currentSort, sortTable }) => {

    const SortableHeader = (props) => <FixedWidthHeader sort={currentSort ?? ""} sortTable={sortTable} {...props}>
        {props.children}
    </FixedWidthHeader>;

    return <thead>
        <tr>
            <SortableHeader width={10} property="runDate">
                Run Date
            </SortableHeader>
            <SortableHeader width={20} property="startedBy">
                Started By
            </SortableHeader>
            <SortableHeader width={20} property="startedBy">
                Clients File
            </SortableHeader>
            <SortableHeader width={20} property="startedBy">
                Holdings File
            </SortableHeader>
            <SortableHeader width={20} property="status">
                Status
            </SortableHeader>
            <SortableHeader width={20} property="totalElapsed">
                Time Taken
            </SortableHeader>
            <ThemedTableHeader width={10} className="text-center">
                Import
            </ThemedTableHeader>
            <ThemedTableHeader width={10} className="text-center">
                Matching
            </ThemedTableHeader>
            <ThemedTableHeader width={10} className="text-center">
                Transactions
            </ThemedTableHeader>
        </tr>
    </thead>;
};

export default HubwiseJobsTableHeader;